import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { convertISODateTimeToString } from '@beef/shop-common';
import { withMountListener } from '@beef/react';
import { compose } from 'redux';

import { getFeedbackPostsAdvanced } from 'store/ProductDetails/selectors';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { onFeedbackMount } from 'store/ProductDetails/feedbackLocal/actions';

import FeedbackPost from '../FeedbackPost/index';
import FeedbackLoader from '../FeedbackLoader/index';

const FeedbackList = ({ items, isMobile }) => (
  <>
    {items.map(
      ({
        id,
        rating,
        userName,
        text,
        publishDate,
        likes,
        dislikes,
        isLiked,
        isDisliked,
        isRated,
        isMostUseful,
        title,
      }) => (
        <FeedbackPost
          key={id}
          author={userName}
          date={convertISODateTimeToString(publishDate)}
          isMobile={isMobile}
          publishDate={publishDate}
          {...{ id, rating, likes, dislikes, isLiked, isDisliked, isRated, isMostUseful, title }}
          isCompact={isMobile}
        >
          {text}
        </FeedbackPost>
      ),
    )}
    <FeedbackLoader />
  </>
);

FeedbackList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      likes: PropTypes.number,
      dislikes: PropTypes.number,
      rating: PropTypes.number,
      publishDate: PropTypes.string,
      text: PropTypes.string,
      userName: PropTypes.string,
      isLiked: PropTypes.bool,
      idDisliked: PropTypes.bool,
      isRated: PropTypes.bool,
      title: PropTypes.string,
    }),
  ),
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  items: getFeedbackPostsAdvanced(state),
  isMobile: isScreenBelow800(state),
});

const mapDispatchToProps = {
  onMount: onFeedbackMount,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withMountListener,
)(FeedbackList);
